(function () {
  function initSecondImageHover() {
    document.querySelectorAll('.l4cl li').forEach(function (li) {
      if (li.dataset.doypackHoverInit) return;
      var pics = li.querySelectorAll('figure picture');
      if (pics.length < 2) return;
      li.dataset.doypackHoverInit = '1';
      var second = pics[1];
      li.addEventListener('mouseenter', function () { second.style.opacity = '1'; });
      li.addEventListener('mouseleave', function () { second.style.opacity = '0'; });
    });
  }
  window.addEventListener('load', initSecondImageHover);
  window.addEventListener('load', function () { setTimeout(initSecondImageHover, 1000); });
})();
